import {faSearch} from '@netx/core-icons';

export const SEARCH_VISUAL_ACTION_ICON = <const>{
	ASSET: faSearch,
	COLOR: faSearch,
};

export type SearchVisualBaseEvent = typeof SEARCH_VISUAL_BASE_EVENT;

export const SEARCH_VISUAL_BASE_EVENT = `search:visual`;

export const SEARCH_VISUAL_EVENT = <const>{
	ASSET: `${SEARCH_VISUAL_BASE_EVENT}:asset`,
	COLOR: `${SEARCH_VISUAL_BASE_EVENT}:color`,
};
